// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"fde55452","2781":"fde55452","3732":"fde55452","4067":"ffde425c","9807":"ffde425c"}[chunkId] + ".chunk.css";
};